import { makeStyles } from '@material-ui/core/styles';

const appInputStyles = makeStyles(theme => ({
  TextBox: {
    width: '92%',
    height: '40px',
    margin: '10px'
  },
}));

export { appInputStyles }